// extracted by mini-css-extract-plugin
module.exports = {"component":"AmbulanceItem_component__3ktIz","stateName":"AmbulanceItem_stateName__3QckA","link":"AmbulanceItem_link__2fiYA"};